import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentAddressTypeSelectionComponent } from './payment-address-type-selection.component';
import { Select2Module } from 'src/app/shared/ui/forms/inputs/oops-select2/select2.module';

@NgModule({
    declarations: [
        PaymentAddressTypeSelectionComponent
    ],
    imports: [
        CommonModule,
        Select2Module
    ],
    exports: [
        PaymentAddressTypeSelectionComponent
    ]
})
export class PaymentAddressTypeSelectionModule { }
